import { useRef } from 'react';
interface ConfettiProps {
  active: boolean;
}
const Confetti: React.FC<ConfettiProps> = ({ active }) => {
  const particles = useRef(
    Array.from({ length: 36 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      delay: Math.random() * 0.6,
      color: ['#a78bfa', '#34d399', '#fbbf24', '#f472b6', '#60a5fa'][i % 5],
      size: 6 + Math.random() * 8,
      drift: (Math.random() - 0.5) * 80,
    }))
  ).current;

  if (!active) return null;
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        pointerEvents: 'none',
        zIndex: 100,
      }}
    >
      <style>{`
        @keyframes confettiFall {
          0%   { transform: translateY(0) translateX(0) rotate(0deg); opacity: 1; }
          100% { transform: translateY(110vh) translateX(var(--drift)) rotate(720deg); opacity: 0; }
        }
      `}</style>
      {particles.map((p) => (
        <div
          key={p.id}
          style={
            {
              position: 'absolute',
              left: `${p.x}%`,
              top: '-20px',
              width: p.size,
              height: p.size,
              borderRadius: Math.random() > 0.5 ? '50%' : '2px',
              background: p.color,
              '--drift': `${p.drift}px`,
              animation: `confettiFall 1.8s ${p.delay}s ease-in forwards`,
            } as React.CSSProperties
          }
        />
      ))}
    </div>
  );
};
export default Confetti;
